export default "__VITE_ASSET__4nroaIqo__"